import React from 'react';
import {
    SiteContainer,
    SubContainer,
    Title,
} from './style';

import siteEnums from '../../../services/enums/sites';

import SiteModelCard from '../SiteModelCard';

const SitesModelsList = () => (
	<SiteContainer>
		<Title>Escolha o site ideal<br />para você</Title>
		<SubContainer>
			<div className="row">
				<div className="col-xl-4 col-12">
					<SiteModelCard siteTier={siteEnums.BASIC} />

				</div>
				<div className="col-xl-4 col-12">
					<SiteModelCard siteTier={siteEnums.PREMIUM} />

				</div>
				<div className="col-xl-4 col-12">
					<SiteModelCard siteTier={siteEnums.PRO} />

				</div>
			</div>
		</SubContainer>
	</SiteContainer>
);

export default SitesModelsList;
